export enum MarketType {
  KAT = 'KAT',
  MARKET = 'MARKET',
}
